import React from 'react';
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function Section4ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {
        buttonText: stringsTranslate(appWords.contact_us),
        headingSection1: stringsTranslate(appWords.building_together),
        subheadingSection1_1: stringsTranslate(appWords.power_of_collaboration_description),
        subheadingSection1_2: stringsTranslate(appWords.discount_partners_expectations_intro),
        subheadingSection1_3: stringsTranslate(appWords.display_qr_code),
        subheadingSection1_4: stringsTranslate(appWords.encourage_favorites),
        playImg1: "/assets/images/ForCompanies/Abri 1.webp",

    }

    {/*<div className="col-lg-12 col-md-12 col-sm-12 text-center button-4-5-section">*/}
    {/*    <KnaekPrimaryButton*/}
    {/*        onClick={() => handleLinkClick("/contact")}*/}
    {/*        title={initStrings.buttonText}*/}
    {/*    />*/}
    {/*</div>*/}

    return (
        <section className="section "  id='buildingTogether'>
            <div className="container-fluid ">

                <div className="row align-items-center justify-content-center section4-for-companies px-2 px-md-5 px-lg-5 pb-5 mt-5 mt-md-0 mt-lg-0">
                    <div className="col-lg-7 col-md-12 flex-wrap d-flex align-items-center mt-lg-5 mt-md-5 mt-3 pl-lg-5 pl-md-5 pl-3 list">
                        <h1 className="heading-section4-for-companies text-knaek-title">{initStrings.headingSection1}</h1>

                        <p className="mt-3  line-text text-knaek-title subheading-section4-for-companies">{initStrings.subheadingSection1_1}</p>
                        <p className="mt-3 line-text text-knaek-title subheading-section4-for-companies">{initStrings.subheadingSection1_2}</p>
                        <ul>
                            <li className={"ml-3 line-text text-knaek-title subheading-list-section4-for-companies"}>
                              {initStrings.subheadingSection1_3}
                            </li>
                            <li className={"ml-3 line-text text-knaek-title subheading-list-section4-for-companies"}>
                                {initStrings.subheadingSection1_4}
                            </li>
                        </ul>
                    </div>

                    <div className="col-lg-5 col-md-12 d-none d-lg-inline flex-wrap d-flex align-items-center mt-0 mt-md-5 mt-lg-5 text-center ">
                        <img src={initStrings.playImg1} className={"image-section4-for-companies ml-5 d-none d-lg-inline "} alt={""}/>
                    </div>
                </div>

            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=NngjpBjS3ME')

        } else {
            window.open('https://www.youtube.com/watch?v=IcuCt12_VOY')

        }

    }

}
